export default __webpack_public_path__ + "static/media/Authorandartist.4e6023e5.txt";